import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { PendingChangesGuard } from 'app/core/pending-changes.guard';
import { PrepareGuard } from 'app/core/prepare.guard';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { ProductOverviewComponent } from './product-overview/product-overview.component';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { InventoryOverviewComponent } from './inventory-overview/inventory-overview.component';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        FormsModule,
        RouterModule.forChild([
            {
                path: 'products',
                canActivate: [PrepareGuard],
                component: BasicLayoutComponent,
                children: [
                    {
                        path: 'overview',
                        component: ProductOverviewComponent,
                        data: { title: 'Product Overview' },
                        canActivate: [PrepareGuard],
                    },
                    {
                        path: 'inventory',
                        component: InventoryOverviewComponent,
                        data: { title: 'Inventory' },
                        canActivate: [PrepareGuard],
                    },
                    {
                        path: ':id',
                        component: ProductDetailComponent,
                        data: { title: 'Product Detail' },
                        canDeactivate: [PendingChangesGuard],
                    },
                ],
            },
        ]),
    ],
    declarations: [ProductOverviewComponent, ProductDetailComponent, InventoryOverviewComponent],
})
export class ProductsModule {}
